export enum ViewBookingViewModeEnum{

  Default=1,
  Extend=2,
  AddRemoveExtras=3,
  ModifyPickUp=4,
  UpdateDriverInfo=5,
}
